import { defineStore } from "pinia";
import ServicesUsers from "@/service/users.js";
import ServiceLicences from "@/service/licences.js";
import useUserStore from "@/store/userState.js";
import useCourseState from "@/store/courseState";

export default defineStore("groupsState", {
  state: () => ({
    groups: [],
    groupsIds: [],
    loading: false,
  }),
  getters: {
    size: (state) => () => {
      return state.groups.size;
    },
    getGroups: (state) => () => {
      return state.groups.size;
    },
    getUsersGroups: (state) => () => {
      return state.groups.size;
    },
    getUsersInGroups: (state) => (ids) => {
      return state.groups
        .filter((group) => ids.includes(group.groupLmsId))
        .flatMap((group) => group.users);
    },
  },
  actions: {
    init(groupsIds) {
      ServicesUsers.getGroupsWithUsers(groupsIds).then(
        (response) => (this.groups = response.data)
      );
    },
    fillUser(groupsIds) {
      ServicesUsers.getGroupsWithUsers(groupsIds).then(
        (response) => (this.groups = response.data)
      );
    },
    async getUserGroups() {
      this.loading = true;
      const userStore = useUserStore();
      const courseState = useCourseState();
      // this.loading = true;

      // FJL: Se recuperan los grupos para el usuario conectado. Los administradores tiene acceso a todos los grupos
      const callGetUserGroup = async (site, licenceId) => {
        if (
          userStore.userRole.includes("ROLE_ADMIN") ||
          userStore.userRole.includes("ROLE_TEACHER")
        ) {
          return await ServiceLicences.getSiteUnirGroups(
            licenceId,
            site,
            userStore.unirId
          ); // SI ES ADMIN O PROFESOR
        } else {
          return await ServiceLicences.getCurrentUserSiteUnirGroups(
            licenceId,
            site
          ); // SI ES TUTOR O ALUMNO
        }
      };

      await callGetUserGroup(courseState.site, courseState.licenceId)
        .then((response) => {
          this.groups = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
